export const _SitemapFormaspagamento = {
    url: 'formasPagamento',
    descricao: 'Formas de pagamento',
    nome: 'Formas de pagamento',
    permissao: ['VisualizarFormaPagamento'],
    fullUrl: '/formasPagamento/menu',
    children:
        {
            ['menu']: {
                url: 'menu',
                descricao: 'Menu de formas de pagamento',
                nome: 'Menu de formas de pagamento',
                permissao: ['VisualizarFormaPagamento'],
                fullUrl: '/formasPagamento/menu',
            },
        },
} as const